module.exports = __webpack_public_path__ + "img/white-lily.d8c81907.jpg";